import { Directive, ElementRef, Input, OnDestroy, OnInit, Renderer2, inject } from '@angular/core'

@Directive({
  selector: '[exScrollAnimation]',
  standalone: true
})
export class ScrollAnimationDirective implements OnInit, OnDestroy {

  private el     = inject(ElementRef);
  private renderer = inject(Renderer2);

  @Input() offset = -80; // px négatif = déclenche quand l'élément est déjà visible dans le viewport

  private observer!: IntersectionObserver;

  ngOnInit() {
    this.observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          this.renderer.addClass(this.el.nativeElement, 'start');
          this.observer.unobserve(this.el.nativeElement);
        });
      },
      { rootMargin: `0px 0px ${this.offset}px 0px`, threshold: 0 }
    );

    this.observer.observe(this.el.nativeElement);
  }

  ngOnDestroy() {
    this.observer?.disconnect();
  }
}
